import React, { MouseEvent, HTMLAttributes } from 'react';
import classnames from 'classnames';

import styles from './Button.module.scss';

type ButtonSize = 'sm' | 'lg' | 'md';
type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'default';
type ButtonType = 'button' | 'submit' | 'reset';

export interface ButtonProps {
	id?: string;
	size?: ButtonSize;
	variant?: ButtonVariant;
	type?: ButtonType;
	disabled?: boolean;
	className?: string;
	onClick(e: MouseEvent<HTMLElement>): void;
	isBlock?: boolean;
	isLoading?: boolean;
	loaderColor?: string;
	children?: any;
}

export const Button = ({
	id,
	size,
	variant,
	type,
	onClick,
	disabled,
	className,
	isLoading,
	children,
	loaderColor,
	isBlock,
	...props
}: ButtonProps) => {
  return (		
    <button 
      className={
        classnames(
          [
            size == 'sm' && styles['lp-button-sm'],
            size == 'md' && styles['lp-button-md'],
            size == 'lg' && styles['lp-button-lg'],
            variant == 'primary' && styles['lp-button-primary'],
            variant == 'secondary' && styles['lp-button-secondary'],
            variant == 'danger' && styles['lp-button-danger'],
            variant == 'ghost' && styles['lp-button-ghost'],
            variant == 'default' && styles['lp-button-default'],
            className && `${className}`,
            isBlock && styles['lp-button-block'],
            isLoading && styles['lp-button-loading'],
          ]
        )}
      onClick={(event) => onClick(event)}
      disabled={(disabled || isLoading) ? true : false}
      {...props}
    >
      {children}
    </button>
  )
};
